import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {translate} from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';

const Config = require('../../config');

class DetailsPatien extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show:  false,
			names:"",
			lastname1:"",
			lastname2:"",
			relationship:"",
			center_name:"",
			number:"",
			social_number:"",
			service:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'offers/patient_details?offers_id='+id,{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					names:response.res.names,
					lastname1:response.res.lastname1,
					lastname2:response.res.lastname2,
					relationship:response.res.patient_relationship,
					center_name:response.res.center_name,
					number:response.res.number,
					social_number:response.res.social_number,
					service:response.res.patient_section_name,
					show: true
				});
			}
		})
		
	}

	handleClose(){
		this.setState({
			names:"",
			lastname1:"",
			lastname2:"",
			relationship:"",
			center_name:"",
			number:"",
			social_number:"",
			show: false
		});
	}

	render(){
		const {t} = this.props;

		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Paciente</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">Nombres</span>
		        				<input className="form-control" type="text" id="names" name="names" 
		        					value={this.state.names} onChange={(e)=>e.preventDefault()} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">A. Paterno</span>
		        				<input className="form-control" type="text" id="lastname1" name="lastname1" 
		        					value={this.state.lastname1} onChange={(e)=>e.preventDefault()} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">A. Materno</span>
		        				<input className="form-control" type="text" id="lastname2" name="lastname2" 
		        					value={this.state.lastname2} onChange={(e)=>e.preventDefault()} disabled />
		        			</div>
		        		</div>
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">No. IMSS</span>
		        				<input className="form-control" type="text" id="social_number" name="social_number" 
		        					value={this.state.social_number} onChange={(e)=>e.preventDefault()} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">No. Expediente</span>
		        				<input className="form-control" type="text" id="number" name="number" 
		        					value={this.state.number} onChange={(e)=>e.preventDefault()} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">Servicio</span>
		        				<input className="form-control" type="text" id="service" name="service" 
		        					value={this.state.service} onChange={(e)=>e.preventDefault()} disabled />
		        			</div>
		        		</div>
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">Parentesco</span>
		        				<input className="form-control" type="text" id="relationship" name="relationship" 
		        					value={this.state.relationship} onChange={(e)=>e.preventDefault()} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-8">
		        				<span className="span-min">Hospital</span>
		        				<input className="form-control" type="text" id="center_name" name="center_name" 
		        					value={this.state.center_name} onChange={(e)=>e.preventDefault()} disabled />
		        			</div>
		        		</div>
					</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')} onClick={this.handleClose}  />
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations') (DetailsPatien);
